import { Nav } from "rsuite";

import FacebookSquareIcon from "@rsuite/icons/legacy/Facebook";
import GithubAltIcon from "@rsuite/icons/legacy/Github";
import TwitterIcon from "@rsuite/icons/legacy/Twitter";
import LinkedInIcon from "@rsuite/icons/legacy/Linkedin";
import "./MainFooter.css";

const MainFooter = () => {
  return (
    <Nav className="footer-container">
      <Nav.Item icon={<FacebookSquareIcon />} className="social-icon"></Nav.Item>
      <Nav.Item icon={<GithubAltIcon />} className="social-icon"></Nav.Item>
      <Nav.Item icon={<TwitterIcon />} className="social-icon"></Nav.Item>
      <Nav.Item icon={<LinkedInIcon />} className="social-icon"></Nav.Item>
    </Nav>
  );
};

export default MainFooter;
